// extracted by mini-css-extract-plugin
export default {"productGrid":"e1-z","centerLink":"f1-z","productSection":"g1-z","item":"h1-z","ctaButton":"i1-z"};